<template>
  <section class="cgc-config" v-loading="loading">
    <div class="cgc-shell">
      <el-alert
        v-if="!schoolDepartmentId"
        title="请先在顶部切换学校后再配置"
        type="info"
        :closable="false"
        show-icon
      />

      <template v-else>
        <div class="cgc-card">
          <div class="cgc-card__head">
            <div>
              <div class="cgc-card__title">班级小组竞赛</div>
              <div class="cgc-card__school">{{ displaySchoolName }}</div>
            </div>
            <el-tag :type="enabled ? 'success' : 'info'" size="small" effect="plain">
              {{ enabled ? '已启用' : '未启用' }}
            </el-tag>
          </div>

          <div class="cgc-card__desc">
            学校级开关。开启后自动创建本校固化任务；关闭后停止本校任务，仅可查看历史排行。
          </div>

          <div class="cgc-switch">
            <div class="cgc-switch__text">
              <div class="cgc-switch__label">启用班级小组竞赛</div>
              <div class="cgc-switch__hint">
                {{ enabled
                  ? '班主任可创建竞赛并调整成员；周期结束后按规则固化排行。'
                  : '当前不能新建或调整进行中竞赛，仅可查看历史固化排行。' }}
              </div>
            </div>
            <el-switch v-model="enabled" active-text="开启" inactive-text="关闭" />
          </div>

          <div class="cgc-tips" :class="enabled ? 'is-on' : 'is-off'">
            <div class="cgc-tips__title">{{ enabled ? '开启后生效' : '关闭后影响' }}</div>
            <ul v-if="enabled">
              <li>允许竞赛管理与成员调整</li>
              <li>自动创建本校周 / 月 / 日期固化任务</li>
              <li>进行中周期实时统计点评分</li>
            </ul>
            <ul v-else>
              <li>禁止新建和调整当前竞赛</li>
              <li>停止本校相关定时任务</li>
              <li>仅保留历史排行快照查看</li>
            </ul>
          </div>

          <div class="cgc-actions">
            <el-button size="small" icon="el-icon-refresh" @click="load">重新加载</el-button>
            <el-button type="primary" size="small" icon="el-icon-check" :loading="saving" @click="save">保存配置</el-button>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { getClassGroupCompetitionConfig, saveClassGroupCompetitionConfig } from '../../api/modules/moral-education';

export default {
  name: 'ClassGroupCompetitionConfig',
  data() {
    return {
      schoolDepartmentId: 0,
      enabled: false,
      saving: false,
      loading: false,
    };
  },
  computed: {
    /**
     * 顶部当前学校名称。
     */
    displaySchoolName() {
      if (!this.schoolDepartmentId) return '未选择学校';
      return this.$store.state.activeSchoolName || `学校 #${this.schoolDepartmentId}`;
    },
  },
  watch: {
    '$store.state.activeSchoolId': {
      immediate: true,
      handler(val) {
        const schoolDepartmentId = Number(val) || 0;
        if (schoolDepartmentId === this.schoolDepartmentId) return;
        this.schoolDepartmentId = schoolDepartmentId;
        this.enabled = false;
        if (schoolDepartmentId) this.load();
      },
    },
  },
  methods: {
    /**
     * 加载当前学校的竞赛开关。
     */
    async load() {
      if (!this.schoolDepartmentId) return;
      this.loading = true;
      try {
        const res = await getClassGroupCompetitionConfig({ schoolDepartmentId: this.schoolDepartmentId });
        const data = res.data || res;
        this.enabled = !!(data.response && data.response.Enabled);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 保存当前学校的竞赛开关。
     */
    async save() {
      if (!this.schoolDepartmentId) return this.$message.warning('请先在顶部切换学校');
      this.saving = true;
      try {
        await saveClassGroupCompetitionConfig({
          SchoolDepartmentId: this.schoolDepartmentId,
          Enabled: this.enabled,
        });
        this.$message.success('保存成功');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.cgc-config {
  min-height: 100%;
  box-sizing: border-box;
  padding: 28px 20px;
  background: #f5f7fa;
}
.cgc-shell {
  width: 100%;
  max-width: 560px;
}
.cgc-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 20px 22px 18px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.cgc-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.cgc-card__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
}
.cgc-card__school {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}
.cgc-card__desc {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
.cgc-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}
.cgc-switch__label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}
.cgc-switch__hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.cgc-tips {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background: #fafafa;
}
.cgc-tips.is-on {
  border-color: #c2e7b0;
  background: #f0f9eb;
}
.cgc-tips.is-off {
  border-color: #e4e7ed;
  background: #f5f7fa;
}
.cgc-tips__title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.cgc-tips.is-on .cgc-tips__title {
  color: #529b2e;
}
.cgc-tips ul {
  margin: 0;
  padding-left: 18px;
  color: #606266;
  font-size: 12px;
  line-height: 1.75;
}
.cgc-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f0f2f5;
}
@media (max-width: 640px) {
  .cgc-config {
    padding: 16px 12px;
  }
  .cgc-switch {
    flex-direction: column;
    align-items: flex-start;
  }
  .cgc-actions {
    justify-content: stretch;
  }
  .cgc-actions .el-button {
    flex: 1;
  }
}
</style>
